import MapType from "./MapType";

export default MapType;
